"use strict";var t=require("react"),e=require("./hasData-cjs-BbcTd98W.js"),r=require("@apollo/client"),a=require("./validationIssue.fragment-cjs-Cw-mgojl.js"),o=require("./cache-cjs-C83XsaeF.js");require("./validateCoverage-cjs-B8rVMz0j.js"),require("./index-cjs-LnAlfZMV.js");var c=require("./CategoryModel-cjs-D7VALxvO.js"),s=require("./isSplitOrdersEnabled-cjs-CJDIoz17.js");require("@sentry/browser"),require("./sentryLogger-cjs-CxKKndNt.js");var u=require("./_rollupPluginBabelHelpers-cjs-Pa8u-b2g.js"),n=require("./searchProducts-cjs-BSN7KvSk.js"),d=require("react/jsx-runtime");function i(t){return t&&t.__esModule?t:{default:t}}var l=i(t);const C=({create:r,remove:a})=>t.useCallback(async()=>{const t=await a();e.h(t)&&r({storeReference:t.store.reference,operationalModel:t.operationalModel,addressId:t?.address?.id})},[r,a]),p=({load:r,convert:a,reset:o,validate:c,loadById:s})=>t.useCallback(async({storeReference:t,addressId:u,operationalModel:n,customer:d,guestCartId:i,loggedCartId:l,callback:C})=>{let p="CART_FAIL_TO_LOAD";if(i)return await a({cartId:i}),p="CART_GUEST_TO_LOGGED",void C(p);if(await o(),t&&n&&d){const a=await r({storeReference:t,addressId:u,operationalModel:n,customer:d});p="CART_LOGGED_BY_LOCALIZATION",e.h(a?.products)&&(await c({cartId:a.id}),p="CART_LOGGED_BY_LOCALIZATION_WITH_PRODUCTS")}if(l){const t=await s({cartId:l});p="CART_LOGGED_BY_ID",e.h(t?.products)&&(await c({cartId:t.id}),p="CART_LOGGED_BY_ID_WITH_PRODUCTS")}C(p)},[o,a,r,c,s]);var m=r.gql`
  query GetDeliverySlots($getDeliverySlotsInput: GetDeliverySlotsInput!) {
    getDeliverySlots(getDeliverySlotsInput: $getDeliverySlotsInput) {
      id
      expiresAt
      from
      to
    }
  }
`;const I=({cartId:e,setDeliverySlots:a,cartStatus:o})=>{const c=r.useApolloClient();return t.useCallback(async({start:t,end:r})=>{if(!e)return null;o.setProgress();try{const{data:s}=await c.query({query:m,context:{version:"v3"},fetchPolicy:"no-cache",variables:{getDeliverySlotsInput:{cartId:e,start:t,end:r}}}),u=s?.getDeliverySlots||[];return a(u),o.setSuccess(),u}catch(t){const e=(({error:t,tags:e})=>{let r=t;return r=t.reason?{message:t.message,code:t.code,reason:t.reason}:(t=>(t=>t.message.includes("LOGISTICS ERROR")&&"INTERNAL_SERVER_ERROR"===t.graphQLErrors?.[0].extensions?.code)(t)?(t=>{const e=(t=>t.graphQLErrors?.[0]?.extensions?.exception?.errors?.error||"LOGISTICS_ERROR")(t);return{message:t.message,code:t.code,reason:e}})(t):{message:t.message,code:t.code,reason:"UNKNOWN_ERROR"})(t),{error:r,tags:e}})({error:t,tags:["load-delivery-slots"]});o.setError(e)}return null},[e,o])},P=({cart:e={},products:r,create:a,validate:o})=>{const{store:c,operationalModel:s,address:u,id:n}=e,d=t.useCallback(()=>{a({storeReference:c.reference,operationalModel:s,addressId:u?.id||null})},[c,u,s,a]),i=t.useCallback(()=>Object.keys(r||{}).length?o({cartId:n}):Promise.resolve(null),[n,o,r]);return t.useCallback(async(t={shouldValidate:!0,shouldCreate:!1})=>{const{shouldValidate:e,shouldCreate:r}=t;return e?i().then(t=>({data:{createCart:t}})):r?d():Promise.resolve(null)},[d,i])},v=({cart:e,create:r,update:a})=>t.useCallback(async t=>{const{storeReference:o,operationalModel:c,addressId:s,customer:u,slot:n,groupId:d,groupAddressId:i,paymentMethod:l,paymentConfigurationId:C,billing:p,onCompleted:m,onError:I,loyalty:P,onlinePaymentParams:v}=t,S={...e},{id:y,store:g,address:f,operationalModel:E}=S;if(!o||!c)return;u&&Object.keys(u).length&&!y&&await r({storeReference:o,operationalModel:c,addressId:s});const $=null===l&&null===n;y&&(g?.reference!==o||E!==c||s&&s!==f?.id)&&await a({storeReference:o,operationalModel:c,addressId:s,cartId:y});y&&(n||l||p||C||P||$||i)&&await a({cartId:y,storeReference:o,operationalModel:c,slot:n,groupId:d,addressId:i,paymentMethod:l,paymentConfigurationId:C,billing:p,loyalty:P,onCompleted:m,onError:I,onlinePaymentParams:v})},[e,r,a]),S={GUEST_CART:"GUEST_CART",LOGGED_CART:"LOGGED_CART",CALLCENTER_CART:"CALLCENTER_CART"},y="DELETED",g="PROGRESS",f="SUCCESS",E="ERROR",$={COULD_NOT_ADD_BILLING_SUCCESSFULLY:"COULD_NOT_ADD_BILLING_SUCCESSFULLY",PROMOTION_CHANGED:"PROMOTION_CHANGED",PRICE_CHANGED:"PRICE_CHANGED",BASE_UNIT_CHANGED:"BASE_UNIT_CHANGED",REMOVED_COUPON:"REMOVED_COUPON",NO_STOCK:"NO_STOCK",NOT_FOUND_IN_CATALOG:"NOT_FOUND_IN_CATALOG",INACTIVE:"INACTIVE",ZERO_PRICE:"ZERO_PRICE",COULD_NOT_VALIDATE_AN_EMPTY_CART:"COULD_NOT_VALIDATE_AN_EMPTY_CART",CART_IS_NOT_BETWEEN_PURCHASE_AMOUNT_BOUNDARIES:"CART_IS_NOT_BETWEEN_PURCHASE_AMOUNT_BOUNDARIES",FORMAT_NOT_AVAILABLE:"FORMAT_NOT_AVAILABLE",COULD_NOT_UPDATE_COUPON:"COULD_NOT_UPDATE_COUPON",PRODUCT_MIN_QUANTITY_NOT_MET:"PRODUCT_MIN_QUANTITY_NOT_MET",PRODUCT_MAX_QUANTITY_EXCEEDED:"PRODUCT_MAX_QUANTITY_EXCEEDED",COUPON_BY_CART_AND_CODE_NOT_FOUND:"COUPON_BY_CART_AND_CODE_NOT_FOUND",TARGET_STORE_NOT_MET:"TARGET_STORE_NOT_MET",TARGET_USER_NOT_MET:"TARGET_USER_NOT_MET",COUPON_CONDITIONS_NOT_MET:"COUPON_CONDITIONS_NOT_MET",INVALID_DATES:"INVALID_DATES",INVALID_SLOT_ID:"INVALID_SLOT_ID"};var b=r.gql`
  fragment CartStore on StoreModel {
    id
    reference
    name
    currency
    dynamicParams
  }
`,T=r.gql`
  fragment TaxesSummary on CartTaxesSummaryModel {
    id
    name
    value
  }
`,h=r.gql`
  ${T}
  fragment CartPricesSummary on PricesSummary {
    shippingFee
    serviceFee {
      isPending
      isFreeService
      serviceFee {
        initial
        final
      }
    }
    taxes
    discounts
    subtotal
    fullPrice
    total
    totalBeforeTaxes
    totalBeforeReservedAmount
    reservedAmount
    attributes {
      type
      name
      value
    }
    taxesSummary {
      ...TaxesSummary
    }
    productsSummary {
      missingForMinimumOrderValue
      missingForFreeShipping
      totalProductsDiscount
      fullProductsPrice
      productsTotal
      missingForMinimumOrderValueBeforeTaxes
      missingForFreeShippingBeforeTaxes
      totalProductsDiscountBeforeTaxes
      fullProductsPriceBeforeTaxes
      productsTotalBeforeTaxes
      isApplicableForFreeShipping
    }
  }
`,A=r.gql`
  fragment CartStoreConfiguration on StoreConfiguration {
    minimumPurchasingAmount
    maximumPurchasingAmount
    serviceFee
    minimumToFreeServiceFee
    isCurbsidePickupEnabled
  }
`,_=r.gql`
  fragment cartCustomer on CustomerModel {
    id
    name
    email
  }
`,D=r.gql`
  fragment cartAddress on AddressModel {
    id
    description
    address {
      structure
      other
    }
    addressTwo
    available
    latitude
    longitude
    city
    state
    zipCode
    removed
    customerId
  }
`,O=r.gql`
  fragment CartCoupon on CouponModel {
    id
    benefits {
      type
      value
    }
    conditions {
      field
      value
      operator
    }
    startDate
    endDate
    code
  }
`,M=r.gql`
  ${b}
  ${h}
  ${A}
  ${_}
  ${D}
  ${O}
  mutation UpdateCouponInCallCenterCart($updateCouponInput: CouponInput!) {
    updateCouponInCallCenterCart(updateCouponInput: $updateCouponInput) {
      id
      status
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      coupon {
        ...CartCoupon
      }
      operationalModel
    }
  }
`;const R=(t,e)=>parseInt(t,10)===parseInt(e,10),N=(t,e)=>r=>{const a=((t,e)=>{const r=R(e,t),a=(c=t,"string"==typeof(o=e)&&"string"==typeof c&&o===c);var o,c;return r||a})(t,r?.reference);return a&&(t=>Boolean(t&&!Number.isNaN(t)))(e)?R(r?.variant,e):a},k=t=>({reference:e,variant:r})=>t?.find(N(e,r))||null;var x=r.gql`
  ${h}
  ${a.C}
  mutation AddProductToCallCenterCart(
    $addProductToCartInput: AddProductToCartInput!
  ) {
    addProductToCallCenterCart(addProductToCartInput: $addProductToCartInput) {
      id
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var U=r.gql`
  ${h}
  ${a.C}
  ${a.a}
  mutation AddSpecialProductToCallCenterCart(
    $addSpecialProductToCallCenterCartInput: AddSpecialProductToCallCenterCartInput!
  ) {
    addSpecialProductToCallCenterCart(
      addSpecialProductToCallCenterCartInput: $addSpecialProductToCallCenterCartInput
    ) {
      id
      products {
        ...CartProduct
      }
      specialProducts {
        ...CartSpecialProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var G=t=>[...t.map(t=>({...t,isSpecialProduct:!0}))],L=r.gql`
  ${b}
  ${h}
  ${a.C}
  ${a.a}
  ${A}
  ${_}
  ${D}
  ${O}
  mutation GetActiveOrCreateCallCenterCart(
    $createCartInput: CreateCallCenterCartInput!
  ) {
    getActiveOrCreateCallCenterCart(createCartInput: $createCartInput) {
      id
      operationalModel
      paymentConfigurationId
      status
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      products {
        ...CartProduct
      }
      specialProducts {
        ...CartSpecialProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      coupon {
        ...CartCoupon
      }
    }
  }
`;var q=r.gql`
  fragment billing on Billing {
    name {
      value
      name
    }
    documentId {
      value
      name
    }
    documentType {
      name
      value
    }
    general {
      name
      value
    }
  }
`,w=r.gql`
  fragment CartAddress on AddressModel {
    id
    description
    address {
      structure
      other
    }
    addressTwo
    available
    latitude
    longitude
    city
    state
    zipCode
    removed
    customerId
  }
`,V=r.gql`
  fragment ProductPrice on ProductPrice {
    taxes
    totalBeforeTaxes
    subtotal
    fullPrice
    discount
    total
    taxesSummary {
      id
      name
      value
      type
      rate
    }
  }
`,B=r.gql`
  fragment PromotionCC on Promotion {
    type
    isActive
    conditions {
      quantity
      price
      priceBeforeTaxes
      taxTotal
      taxes {
        taxId
        taxName
        taxType
        taxValue
        taxSubTotal
      }
    }
    description
    endDateTime
    startDateTime
    isApplied
  }
`,Q=r.gql`
  ${a.S}
  ${V}
  ${B}
  fragment CartProductCC on CartProductModel {
    id
    unitQuantity
    baseUnitPrice
    baseUnitPriceBeforeTaxes
    reference
    unit
    variant
    instruction
    status
    imageUrl
    price {
      ...ProductPrice
    }
    maxUnitQuantity
    minUnitQuantity
    name
    createdAt
    updatedAt
    availability
    baseUnit
    promotion {
      ...PromotionCC
    }
    stockWarning
    substitutes {
      ...Substitutes
    }
  }
`,j=r.gql`
  ${V}
  fragment CartSpecialProductCC on CartSpecialProductModel {
    id
    unitQuantity
    unit
    instruction
    imageUrl
    sku
    price {
      ...ProductPrice
    }
    name
    status
    createdAt
    updatedAt
  }
`,F=r.gql`
  fragment CartStoreCC on StoreModel {
    id
    name
    reference
    currency
    longitude
    latitude
    address
    addressTwo
    country
    state
    zipCode
    operationalModelsPriority {
      DELIVERY
      PICK_AND_COLLECT
    }
    slotSize
    dynamicParams
  }
`,z=r.gql`
  fragment CartCustomer on CustomerModel {
    id
    name
    email
    phoneNumber
    customData {
      identificationType
      identificationNumber
      billing
    }
    documentId
    uid
    provider
    terms
    notifications
    shoppingCartVersion
    organizationId
    segments
    externalId
    phoneNumberValidated
  }
`,Y=r.gql`
  fragment deliverySlot on DeliverySlotModel {
    id
    from
    to
    expiresAt
    groupId
    type
    prices {
      initial
      isFreeService
      final
    }
  }
`,H=r.gql`
  fragment Quotation on QuotationModel {
    id
    status
    customer {
      id
      name
      email
      phoneNumber
      customData {
        identificationType
        identificationNumber
        billing
      }
      documentId
      uid
      provider
      terms
      notifications
      shoppingCartVersion
      organizationId
      segments
      externalId
      phoneNumberValidated
    }
    address {
      id
      description
      address {
        structure
        other
      }
      addressTwo
      available
      latitude
      longitude
      city
      state
      zipCode
      removed
      customerId
    }
    store {
      id
      name
      reference
      currency
      longitude
      latitude
      address
      addressTwo
      country
      state
      zipCode
      operationalModelsPriority {
        DELIVERY
        PICK_AND_COLLECT
      }
      slotSize
      dynamicParams
    }
    number
    comment
    currency
    callCenterAgent {
      name
      email
    }
    operationalModel
    clientId
    itemsQuantity
    pricesSummary {
      shippingFee
      taxes
      discounts
      subtotal
      fullPrice
      total
      totalBeforeTaxes
      attributes {
        type
        name
        value
      }
      taxesSummary {
        id
        name
        value
      }
    }
    expiresAt
    purchasedAt
    products {
      id
      quotationId
      unitQuantity
      reference
      instruction
      imageUrl
      baseUnitPrice
      baseUnitQuantity
      conversionFactor
      promotion {
        type
        isActive
        conditions {
          quantity
          price
          priceBeforeTaxes
          taxTotal
          taxes {
            taxId
            taxName
            taxType
            taxValue
            taxSubTotal
          }
        }
        description
        endDateTime
        startDateTime
        isApplied
      }
      unit
      baseUnit
      name
      attributes {
        sku
        ean
        category
        location
      }
      categories {
        reference
        name
        path
        slug
        level
        boost
        isAvailableInHome
        hasChildren
        active
        categoryNamesPath
        isAssociatedToCatalog
      }
      price {
        taxes
        totalBeforeTaxes
        subtotal
        fullPrice
        discount
        total
        taxesSummary {
          id
          name
          value
          type
          rate
        }
      }
      pricePerBaseUnit {
        taxes
        totalBeforeTaxes
        subtotal
        fullPrice
        discount
        total
        taxesSummary {
          id
          name
          value
          type
          rate
        }
      }
      maxUnitQuantity
      minUnitQuantity
      stockDetails {
        storeReference
        stock
      }
      brand
      baseUnitPriceBeforeTaxes
    }
    createdAt
  }
`,K=r.gql`
  ${Q}
  ${j}
  ${z}
  ${F}
  ${w}
  ${h}
  ${A}
  ${Y}
  ${a.V}
  ${q}
  ${H}
  query GetCallCenterCart($cartId: ID!) {
    getCallCenterCart(cartId: $cartId) {
      id
      operationalModel
      products {
        ...CartProductCC
      }
      specialProducts {
        ...CartSpecialProductCC
      }
      customer {
        ...CartCustomer
      }
      store {
        ...CartStoreCC
      }
      address {
        ...CartAddress
      }
      status
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      coupon {
        id
        benefits {
          type
          value
        }
        conditions {
          field
          value
          operator
        }
        constraints {
          type
          value
        }
        startDate
        endDate
        code
      }
      deliverySlot {
        ...deliverySlot
      }
      validationIssues {
        ...validationIssue
      }
      billing {
        ...billing
      }
      paymentConfigurationId
      loyalty {
        selectedRedemption {
          points
          conversionRate
          conversionValue
        }
      }
      quotation {
        ...Quotation
      }
    }
  }
`;var W=r.gql`
  mutation PurchaseCallCenterCart($purchaseCartInput: PurchaseCartInput!) {
    purchaseCallCenterCart(purchaseCartInput: $purchaseCartInput) {
      id
      status
      operationalModel
      jobId
      jobNumber
      coupon
      lobbyScreenToken
    }
  }
`;var X=r.gql`
  ${b}
  ${D}
  ${h}
  mutation DeleteCallCenterCart($cartId: ID!) {
    deleteCallCenterCart(cartId: $cartId) {
      id
      operationalModel
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      status
    }
  }
`;const Z=t=>t?.status===y;var J=r.gql`
  ${h}
  mutation DeleteProductInCallCenterCart(
    $deleteProductInCartInput: DeleteProductInCartInput!
  ) {
    deleteProductInCallCenterCart(
      deleteProductInCartInput: $deleteProductInCartInput
    ) {
      id
      pricesSummary {
        ...CartPricesSummary
      }
      status
    }
  }
`;var tt=r.gql`
  ${h}
  mutation DeleteSpecialProductInCallCenterCart(
    $deleteSpecialProductInCartInput: DeleteSpecialProductInCartInput!
  ) {
    deleteSpecialProductInCallCenterCart(
      deleteSpecialProductInCartInput: $deleteSpecialProductInCartInput
    ) {
      id
      pricesSummary {
        ...CartPricesSummary
      }
      status
    }
  }
`;var et=r.gql`
  ${b}
  ${h}
  ${A}
  ${_}
  ${D}
  ${O}
  ${q}
  mutation UpdateCallCenterCart($updateCartInput: UpdateCallCenterCartInput!) {
    updateCallCenterCart(updateCartInput: $updateCartInput) {
      id
      operationalModel
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      coupon {
        ...CartCoupon
      }
      status
      billing {
        ...billing
      }
    }
  }
`;var rt=r.gql`
  ${h}
  ${a.C}
  mutation UpdateProductInCallCenterCart(
    $updateProductInCartInput: UpdateProductInCallCenterCartInput!
  ) {
    updateProductInCallCenterCart(
      updateProductInCartInput: $updateProductInCartInput
    ) {
      id
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var at=r.gql`
  ${h}
  ${a.C}
  mutation UpdateSpecialProductInCallCenterCart(
    $updateSpecialProductInCallCenterCartInput: UpdateSpecialProductInCallCenterCartInput!
  ) {
    updateSpecialProductInCallCenterCart(
      updateSpecialProductInCallCenterCartInput: $updateSpecialProductInCallCenterCartInput
    ) {
      id
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var ot=r.gql`
  ${a.P}
  ${c.b}
  fragment ValidateCartProduct on ValidatedCartProductModel {
    id
    name
    unitQuantity
    baseUnitPrice
    reference
    unit
    baseUnit
    variant
    instruction
    status
    imageUrl
    maxUnitQuantity
    minUnitQuantity
    slug
    showSubUnit
    subQuantity
    subUnit
    clickMultiplier
    allowSubstitutions
    price {
      ...PricePerBaseUnit
    }
    pricePerBaseUnit {
      ...PricePerBaseUnit
    }
    promotion {
      ...Promotion
    }
    createdAt
    updatedAt
    availability
    stockWarning
    categoriesData {
      reference
      name
      isAssociatedToCatalog
    }
    isSample
    type
    substitutes {
      substituteMode
      substituteProducts
    }
  }
`,ct=r.gql`
  ${b}
  ${h}
  ${ot}
  ${a.a}
  ${A}
  ${a.V}
  ${_}
  ${D}
  ${H}
  mutation ValidateCallCenterCart($cartId: ID!) {
    validateCallCenterCart(cartId: $cartId) {
      id
      operationalModel
      products {
        ...ValidateCartProduct
      }
      specialProducts {
        ...CartSpecialProduct
      }
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      validationIssues {
        ...validationIssue
      }
      status
      quotation {
        ...Quotation
      }
    }
  }
`,st=r.gql`
  fragment CartGroups on CartGroup {
    id
    isBigOrder
    operationalModel
    slotsDays
    slotsStartOffset
    storeReference
    products {
      id
      unitQuantity
      baseUnitPrice
      reference
      unit
      variant
      instruction
      status
      imageUrl
      price {
        subtotal
        discount
        total
      }
      promotion {
        type
        isActive
        conditions {
          quantity
          price
        }
        description
        endDateTime
        startDateTime
      }
      maxUnitQuantity
      minUnitQuantity
      name
      createdAt
      updatedAt
      availability
      baseUnit
    }
    address {
      id
      description
      address {
        structure
        other
      }
      addressTwo
      available
      latitude
      longitude
      city
      state
      zipCode
      removed
      customerId
      distanceToStore
    }
    store {
      name
    }
  }
`,ut=r.gql`
  ${b}
  ${h}
  ${ot}
  ${a.a}
  ${A}
  ${a.V}
  ${_}
  ${D}
  ${H}
  ${st}
  mutation ValidateCallCenterCart($cartId: ID!) {
    validateCallCenterCart(cartId: $cartId) {
      id
      operationalModel
      products {
        ...ValidateCartProduct
      }
      specialProducts {
        ...CartSpecialProduct
      }
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      validationIssues {
        ...validationIssue
      }
      status
      quotation {
        ...Quotation
      }
      groups {
        ...CartGroups
      }
    }
  }
`;const nt=e=>{const a=(({setCart:e,cartStatus:a})=>{const[o]=r.useMutation(et,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({updateCallCenterCart:{products:t,...r}})=>{e(r)},onError:t=>{a.setError({error:t})}});return t.useCallback(async({storeReference:t,operationalModel:e,addressId:r,cartId:a,slot:c,billing:s,groupId:u,paymentConfigurationId:n,onlinePaymentParams:d})=>{const{data:i={}}=await o({variables:{updateCartInput:{cartId:a,storeReference:t,operationalModel:e,addressId:r,slot:c,billing:s,groupId:u,paymentConfigurationId:n,onlinePaymentParams:d}}});return i.updateCallCenterCart||null},[o])})(e),c=(({setCart:e,addProducts:a,cartStatus:c,reset:s,update:u})=>{const[n]=r.useMutation(L,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({getActiveOrCreateCallCenterCart:{products:t=[],specialProducts:r=[],...o}})=>{a([...t,...G(r)]),e(o)},onError:t=>{s(),c.setError({error:t})}});return t.useCallback(async({storeReference:t,operationalModel:e,addressId:r})=>{const{customer:a}=o.s(),{data:c={}}=await n({variables:{createCartInput:{storeReference:t,operationalModel:e,addressId:r,customer:a?.id}}});return"DELIVERY"===e?await u({storeReference:t,operationalModel:e,addressId:r,cartId:c.getActiveOrCreateCallCenterCart.id})||null:c.getActiveOrCreateCallCenterCart||null},[n,u])})({update:a,...e}),s=(({setCart:e,addProducts:a,cartStatus:o,reset:c})=>{const[s]=r.useLazyQuery(K,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({getCallCenterCart:{products:t,specialProducts:r=[],...o}})=>{a([...t,...G(r)]),e(o)},onError:t=>{c(),o.setError({error:t})}});return t.useCallback(async({cartId:t})=>{const{data:e={}}=await s({variables:{cartId:t}});return e.getCallCenterCart||null},[s])})(e),u=(({cartId:e,reset:a,cartStatus:o})=>{const[c]=r.useMutation(X,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({deleteCallCenterCart:t})=>{t.status===y&&a()},onError:t=>o.setError({error:t})});return t.useCallback(async()=>{if(!e)return null;const{data:t={}}=await c({variables:{cartId:e}});return t.deleteCallCenterCart&&Z(t.deleteCallCenterCart)?t.deleteCallCenterCart:null},[c,e])})(e),n=(({setCart:e,cartStatus:a,addProducts:o,setGroups:c,allowSplitOrders:s})=>{const u=s?ut:ct,[n]=r.useMutation(u,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({validateCallCenterCart:{products:t=[],specialProducts:r=[],...s}})=>{e(s),c(s?.groups||[]),o([...t,...G(r)]),a.setSuccess()},onError:t=>{a.setError({error:t})}});return t.useCallback(async({cartId:t})=>{a.setProgress();const{data:e={}}=await n({variables:{cartId:t}});return e.validateCallCenterCart||null},[n,a])})(e),d=v({cart:e.cart,create:c,update:a}),i=C({create:c,remove:u}),l=(({cartId:e,addProduct:a,productStatus:o,updateCart:c,copy:s})=>{const[u]=r.useMutation(x,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({reference:t,variant:r,unit:n,unitQuantity:d,instruction:i})=>{o.setProgress({reference:t,variant:r}),u({variables:{addProductToCartInput:{cartId:e,reference:t,variant:r,unit:n,unitQuantity:d,instruction:i}}}).then(({data:e})=>{a(k(e.addProductToCallCenterCart.products)({reference:t,variant:r})),c({pricesSummary:e.addProductToCallCenterCart.pricesSummary}),o.setSuccess({reference:t,variant:r})}).catch(e=>{o.setError({reference:t,variant:r,error:e,message:s?.errors?.addProduct})})},[e,a,u,o,c,s])})(e),m=(({cartId:e,addProduct:a,productStatus:o,updateCart:c,copy:s})=>{const[u]=r.useMutation(U,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({quantity:t,instruction:r,name:n,price:d,sku:i,unit:l})=>{u({variables:{addSpecialProductToCallCenterCartInput:{cartId:e,instruction:r,name:n,price:d,sku:i,unit:l,unitQuantity:Number(t)}}}).then(({data:t})=>{const{specialProducts:e,pricesSummary:r}=t.addSpecialProductToCallCenterCart,s=e[e.length-1];a(s),c({pricesSummary:r}),o.setSuccess(s.id)}).catch(t=>{o.setError({error:t,message:s?.errors?.addProduct})})},[e,a,u,o,c,s])})(e),g=(({cartId:e,products:a,updateProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(rt,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(async({productId:t,variant:r,unit:d,unitQuantity:i,instruction:l,editedPrice:C,substitutes:p})=>{const{reference:m}=a[t];c.setProgress({reference:m,variant:r});try{const a=await n({variables:{updateProductInCartInput:{cartId:e,productId:t,variant:r,unit:d,unitQuantity:i,instruction:l,substitutes:p,promotion:C?{type:"NEGOTIATED",condition:{price:C}}:void 0}}}),{data:u}=a;return await o(k(u.updateProductInCallCenterCart.products)({reference:m,variant:r})),await s({pricesSummary:u.updateProductInCallCenterCart.pricesSummary}),c.setSuccess({reference:m,variant:r}),a}catch(t){c.setError({reference:m,variant:r,error:t,message:u?.errors?.updateProduct})}return null},[a,c,n,e,o,s,u?.errors?.updateProduct])})(e),f=(({cartId:e,products:a,updateProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(at,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({specialProductId:t,unit:r,unitQuantity:d,instruction:i})=>{const{reference:l}=a[t];c.setProgress({reference:l}),n({variables:{updateSpecialProductInCallCenterCartInput:{cartId:e,specialProductId:t,unit:r,unitQuantity:d,instruction:i}}}).then(async({data:t})=>{o(k(t.updateSpecialProductInCallCenterCart.specialProducts)({reference:l})),s({pricesSummary:t.updateSpecialProductInCallCenterCart.pricesSummary}),c.setSuccess({reference:l})}).catch(t=>{c.setError({reference:l,error:t,message:u?.errors?.updateProduct})})},[a,c,n,e,o,s,u?.errors?.updateProduct])})(e),E=(({cartId:e,products:a,removeProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(J,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({productId:t})=>{const{reference:r,variant:d}=a[t];c.setProgress({reference:r,variant:d}),n({variables:{deleteProductInCartInput:{cartId:e,productId:t}}}).then(({data:e})=>{o({productId:t}),s({pricesSummary:e.deleteProductInCallCenterCart.pricesSummary}),c.setSuccess({reference:r,variant:d})}).catch(t=>{c.setError({reference:r,variant:d,error:t,message:u?.errors?.removeProduct})})},[e,a,n,o,c,s,u])})(e),$=(({cartId:e,products:a,removeProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(tt,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({specialProductId:t})=>{const{reference:r}=a[t];c.setProgress({reference:r}),n({variables:{deleteSpecialProductInCartInput:{cartId:e,specialProductId:t}}}).then(({data:e})=>{o({productId:t}),s({pricesSummary:e.deleteSpecialProductInCallCenterCart.pricesSummary}),c.setSuccess({reference:r})}).catch(t=>{c.setError({reference:r,error:t,message:u?.errors?.removeProduct})})},[e,a,n,o,c,s,u])})(e),b=I(e),T=(({setCart:e,cart:a})=>{const[o]=r.useMutation(M,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({updateCouponInCallCenterCart:{products:t,...r}})=>{e(r)},onError:()=>{e({...a,coupon:{isInvalid:!0}})}});return t.useCallback(async({couponCode:t,cartId:e})=>{const{data:{updateCouponInCallCenterCart:r}={}}=await o({variables:{updateCouponInput:{cartId:e,couponCode:t}}});return r},[o])})(e),h=(({cartId:e,setPurchaseData:a,cartStatus:o,allowSplitOrders:c})=>{const[s]=r.useMutation(W,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({purchaseCallCenterCart:t})=>{a(t),o.setSuccess()},onError:t=>{o.setError({error:{...t,reason:"INVALID_SLOT_ID"}})}});return t.useCallback(async({paymentInput:t})=>{if(!e)return null;o.setProgress();const{data:r={}}=await s({variables:{purchaseCartInput:{cartId:e,paymentInput:t,allowSplitOrders:c}}});return r.purchaseCallCenterCart||null},[c,e,o,s])})({cartId:e.cartId,setPurchaseData:e.setPurchaseData,cartStatus:e.cartStatus,allowSplitOrders:e.allowSplitOrders});return{addSpecialProduct:m,removeSpecialProduct:$,updateSpecialProduct:f,addProduct:l,clear:i,create:c,initializer:p({load:c,reset:e.reset,validate:n,loadById:s}),load:c,refetch:P({...e,validate:n,create:c}),remove:u,removeProduct:E,restart:d,type:S.CALLCENTER_CART,updateProduct:g,validate:n,loadDeliverySlots:b,addCoupon:T,purchase:h}},dt=({products:e,validate:r,cartId:a,productStatus:o})=>{const c=t.useCallback(async()=>{await r({cartId:a})},[r,a]),s=t.useCallback(()=>{if(!o?.getProductStatus)return!1;const t=(({products:t})=>!(!t||"object"!==u._(t))&&Object.values(t).some(t=>"PACKAGE"===t.type||"BAG"===t.type))({products:e}),r=Object.values(o?.getProductStatus()||{});if(0===r.length)return!1;const a=r.every(t=>t&&t.code===f);return t&&a},[e,o]);((e,r,a)=>{const o=t.useRef(null);t.useEffect(()=>(o.current&&clearTimeout(o.current),o.current=setTimeout(()=>{e()},r),()=>{o.current&&clearTimeout(o.current)}),a)})(()=>{s()&&c()},800,[o?.getProductStatus])},it="cartId",lt={},Ct=[],pt={},mt=[],It={},Pt=(t,e)=>`${t}-${e||""}`;var vt=({site:t,isLogged:e,loggedCart:r,guestCart:a,callCenterCart:o})=>"sales"===t?o:e?r:a;const St=({site:r,cartId:a,products:o,params:c,useLoggedCart:s,useGuestCart:u,useCallCenterCart:n})=>{const d=u(c),i=s(c),l=n(c),[C,p]=t.useState(!1),m=t.useCallback(async({isLogged:t,callback:c,storedCartId:s,...u})=>{const n=vt({site:r,callCenterCart:l,isLogged:t,loggedCart:i,guestCart:d}),m=(({localIsLogged:t,isLogged:r,products:a,cartId:o,storedCartId:c=null})=>!t&&r&&e.h(a)?o:c)({localIsLogged:C,isLogged:t,products:o,cartId:a,storedCartId:s}),I=(({localIsLogged:t,isLogged:e,cartId:r})=>t!==e?null:r)({localIsLogged:C,isLogged:t,cartId:a});p(t),await n.initializer({...u,cartId:I,guestCartId:m,callback:c})},[r,a,o,C,i,d,l]);return[vt({site:r,callCenterCart:l,isLogged:C,loggedCart:i,guestCart:d}),m]},yt=()=>{},gt=({useCallCenterCart:e,useLoggedCart:r,useGuestCart:a,db:o,monitor:c,copy:u,site:n,config:d})=>{const i=s.i(),{clientId:l,checkoutV3:C,enabledCoverageValidation:p}=d||{},m=(({monitor:e})=>{const[r,a]=t.useState(It),o=t.useCallback(()=>a({code:g}),[]),c=t.useCallback(()=>a({code:f}),[]),s=t.useCallback(({error:t,tags:r=[]})=>{a({code:E,error:t}),e.add({error:t,tags:[...r,"cart-v3-track"]})},[e]),u=t.useCallback(()=>r.code===g,[r]),n=t.useCallback(()=>r.code===f,[r]),d=t.useCallback(()=>r.code===E?r:null,[r]),i=t.useCallback(()=>a(It),[]);return t.useMemo(()=>({setProgress:o,setSuccess:c,setError:s,inProgress:u,inSuccess:n,hasErrors:d,resetStatus:i}),[o,c,s,u,n,d,i])})({monitor:c}),I=(({monitor:e})=>{const[r,a]=t.useState({}),o=t.useCallback(({reference:t,variant:e})=>{a(r=>({...r,[Pt(t,e)]:{code:g}}))},[]),c=t.useCallback(({reference:t,variant:e})=>a(r=>({...r,[Pt(t,e)]:{code:f}})),[]),s=t.useCallback(({reference:t,variant:r,message:o,error:c})=>{a(e=>({...e,[Pt(t,r)]:{code:E,message:o}})),e.add({error:c,tags:["cart-products-v3-track"]})},[e]),u=t.useCallback(({reference:t,variant:e})=>r[Pt(t,e)]?.code===g,[r]),n=t.useCallback(({reference:t,variant:e})=>r[Pt(t,e)]?.code===f,[r]),d=t.useCallback(({reference:t,variant:e})=>{const a=Pt(t,e);return r[a]?.code===E?r[a]:null},[r]),i=t.useCallback(()=>a({}),[]),l=t.useCallback(()=>r,[r]);return t.useMemo(()=>({setProgress:o,setSuccess:c,setError:s,inProgress:u,inSuccess:n,hasErrors:d,resetStatus:i,getProductStatus:l}),[o,c,s,u,n,d,i,l])})({monitor:c}),{cartId:P,setCartId:v,resetCartId:S}=(({db:e})=>{const[r,a]=t.useState(()=>e.getItem(it)||null),o=t.useCallback(t=>{a(t),e.setItem(it,t)},[e]),c=t.useCallback(()=>{o(null)},[o]);return{cartId:r,setCartId:o,resetCartId:c}})({db:o}),{cart:y,setCart:$,updateCart:b,resetCart:T,deliverySlots:h,setDeliverySlots:A,purchaseData:_,setPurchaseData:D,groups:O,setGroups:M}=(({setCartId:e,resetCartId:r})=>{const[a,o]=t.useState(lt),[c,s]=t.useState(Ct),[u,n]=t.useState([]),[d,i]=t.useState(pt),l=t.useCallback(t=>{e(t.id),o(t)},[e]),C=t.useCallback(t=>{o(e=>({...e,...t}))},[]),p=t.useCallback((t=Ct)=>{s(t)},[]),m=t.useCallback((t=pt)=>{i(t)},[]),I=t.useCallback((t=mt)=>{n(t)},[]);return{cart:a,setCart:l,updateCart:C,resetCart:t.useCallback(()=>{r(),o(lt),s(Ct),i(pt)},[r]),deliverySlots:c,setDeliverySlots:p,groups:u,setGroups:I,purchaseData:d,setPurchaseData:m}})({setCartId:v,resetCartId:S}),{products:R,addProduct:N,addProducts:x,updateProduct:U,getProduct:G,removeProduct:L,resetProducts:q}=(()=>{const[e,r]=t.useState({}),a=t.useMemo(()=>{const t=Object.values(e);return k(t)},[e]),o=t.useCallback(t=>{t?.id&&r(e=>({...e,[t.id]:{...t,dateHash:Date.now()}}))},[]),c=t.useCallback(t=>{r(t.reduce((t,e)=>({...t,[e.id]:{...e,dateHash:Date.now()}}),{}))},[]),s=t.useCallback(t=>{r(e=>{const r={...e};return r[t.id]={...r[t.id],...t,dateHash:Date.now()},r})},[]),u=t.useCallback(({reference:t,variant:e})=>a({reference:t,variant:e}),[a]),n=t.useCallback(({productId:t})=>{r(e=>{const r={...e};return delete r[t],r})},[]),d=t.useCallback(()=>{r({})},[]);return{products:e,addProduct:o,addProducts:c,updateProduct:s,getProduct:u,removeProduct:n,resetProducts:d}})(),w=(({resetCartStatus:e,resetProductStatus:r,resetCart:a,resetProducts:o})=>t.useCallback(()=>{e(),r(),a(),o()},[e,r,a,o]))({resetCartStatus:m.resetStatus,resetProductStatus:I.resetStatus,resetCart:T,resetProducts:q}),V=t.useMemo(()=>({clientId:l,cartStatus:m,productStatus:I,cartId:P,cart:y,products:R,setCart:$,updateCart:b,reset:w,addProduct:N,addProducts:x,updateProduct:U,removeProduct:L,setDeliverySlots:A,setPurchaseData:D,setGroups:M,copy:u,allowSplitOrders:i,enabledCoverageValidation:p,checkoutV3:C}),[l,m,I,P,y,R,$,b,w,N,x,U,L,A,D,M,u,i,p,C]),[B,Q]=St({site:n,cartId:P,products:R,params:V,useCallCenterCart:e,useLoggedCart:r,useGuestCart:a});return dt({...V,validate:B.validate}),t.useMemo(()=>({initializer:Q,cartStatus:m,productStatus:I,cartId:P,cart:y,products:R,type:B.type,create:B.create,remove:B.remove,load:B.load,validate:B.validate,restart:B.restart,clear:B.clear,addProduct:B.addProduct,addSpecialProduct:B.addSpecialProduct,updateProduct:B.updateProduct,updateSpecialProduct:B.updateSpecialProduct,getProduct:G,removeProduct:B.removeProduct,removeSpecialProduct:B.removeSpecialProduct,loadDeliverySlots:B?.loadDeliverySlots||yt,deliverySlots:h,purchase:B?.purchase||yt,purchaseData:_,groups:O,refetch:B.refetch,addCoupon:B?.addCoupon||yt,reset:w}),[Q,m,I,P,y,R,B.type,B.create,B.remove,B.load,B.validate,B.restart,B.clear,B.addProduct,B.addSpecialProduct,B.updateProduct,B.updateSpecialProduct,B.removeProduct,B.removeSpecialProduct,B.loadDeliverySlots,B.purchase,B.refetch,B.addCoupon,G,h,_,O,w])};var ft=r.gql`
  ${h}
  ${a.C}
  mutation AddProductToGuestCart(
    $addProductToCartInput: AddProductToCartInput!
  ) {
    addProductToGuestCart(addProductToCartInput: $addProductToCartInput) {
      id
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var Et=r.gql`
  ${b}
  ${h}
  ${A}
  mutation CreateGuestCart($createCartInput: CreateGuestCartInput!) {
    createGuestCart(createCartInput: $createCartInput) {
      id
      operationalModel
      store {
        ...CartStore
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      status
    }
  }
`;var $t=r.gql`
  ${b}
  ${h}
  ${a.C}
  ${A}
  query GetGuestCart($cartId: ID!) {
    getGuestCart(cartId: $cartId) {
      id
      operationalModel
      products {
        ...CartProduct
      }
      store {
        ...CartStore
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      status
    }
  }
`;var bt=r.gql`
  ${b}
  ${h}
  mutation DeleteGuestCart($cartId: ID!) {
    deleteGuestCart(cartId: $cartId) {
      id
      operationalModel
      store {
        ...CartStore
      }
      pricesSummary {
        ...CartPricesSummary
      }
      status
    }
  }
`;var Tt=r.gql`
  ${h}
  mutation DeleteProductInGuestCart(
    $deleteProductInCartInput: DeleteProductInCartInput!
  ) {
    deleteProductInGuestCart(
      deleteProductInCartInput: $deleteProductInCartInput
    ) {
      id
      pricesSummary {
        ...CartPricesSummary
      }
      status
    }
  }
`;var ht=r.gql`
  ${b}
  ${h}
  ${A}
  mutation UpdateGuestCart($updateCartInput: UpdateGuestCartInput!) {
    updateGuestCart(updateCartInput: $updateCartInput) {
      id
      operationalModel
      store {
        ...CartStore
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      status
    }
  }
`;var At=r.gql`
  ${h}
  ${a.C}
  mutation UpdateProductInGuestCart(
    $updateProductInCartInput: UpdateProductInCartInput!
  ) {
    updateProductInGuestCart(
      updateProductInCartInput: $updateProductInCartInput
    ) {
      id
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var _t=r.gql`
  ${b}
  ${h}
  ${ot}
  ${A}
  ${a.V}
  mutation ValidateGuestCart($cartId: ID!) {
    validateGuestCart(cartId: $cartId) {
      id
      operationalModel
      products {
        ...ValidateCartProduct
      }
      store {
        ...CartStore
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      validationIssues {
        ...validationIssue
      }
      status
    }
  }
`;const Dt=a=>{const o=(({setCart:e,cartStatus:a,addProducts:o,setGroups:c})=>{const[s]=r.useMutation(_t,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({validateGuestCart:{products:t,...r}})=>{e(r),c(r?.groups||[]),o(t),a.setSuccess()},onError:t=>{a.setError({error:t})}});return t.useCallback(async({cartId:t})=>{a.setProgress();const{data:e={}}=await s({variables:{cartId:t}});return e.validateGuestCart||null},[s,a])})(a),c=(({setCart:e,cartStatus:a})=>{const[o]=r.useMutation(Et,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({createGuestCart:t})=>{e(t)},onError:t=>a.setError({error:t})});return t.useCallback(async({storeReference:t,operationalModel:e,clientId:r})=>{await o({variables:{createCartInput:{storeReference:t,operationalModel:e,clientId:r}}})},[o])})(a),s=(({cartId:e,setCart:a,cartStatus:o})=>{const[c]=r.useMutation(ht,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({updateGuestCart:{products:t,...e}})=>{a(e)},onError:t=>{o.setError({error:t})}});return t.useCallback(async({storeReference:t,operationalModel:r})=>{await c({variables:{updateCartInput:{cartId:e,storeReference:t,operationalModel:r}}})},[c,e])})(a),u=(({setCart:e,cartStatus:a,addProducts:o,reset:c})=>{const[s]=r.useLazyQuery($t,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({getGuestCart:{products:t,...r}})=>{a.setSuccess(),Z(r)?c():(e(r),o(t))},onError:t=>{c(),a.setError({error:t})}});return t.useCallback(async({cartId:t})=>{a.setProgress();const{data:e={}}=await s({variables:{cartId:t}});return e.getGuestCart&&!Z(e.getGuestCart)?e.getGuestCart:null},[s,a])})(a),n=(({cartId:e,reset:a,cartStatus:o})=>{const[c]=r.useMutation(bt,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({deleteGuestCart:t})=>{Z(t)&&a()},onError:t=>o.setError({error:t})});return t.useCallback(async()=>{if(!e)return null;const{data:t={}}=await c({variables:{cartId:e}});return t.deleteGuestCart&&Z(t.deleteGuestCart)?t.deleteGuestCart:null},[e,c])})(a),d=(({cart:e,create:r,update:a})=>t.useCallback(async({clientId:t,storeReference:o,operationalModel:c})=>{t&&o&&c&&(e.id?e.operationalModel===c&&e.store.reference===o||await a({storeReference:o,operationalModel:c}):await r({clientId:t,storeReference:o,operationalModel:c}))},[e,r,a]))({cart:a.cart,create:c,update:s}),i=(({cartId:e,addProduct:a,productStatus:o,updateCart:c,copy:s})=>{const[u]=r.useMutation(ft,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({reference:t,variant:r,unit:n,unitQuantity:d,instruction:i})=>{o.setProgress({reference:t,variant:r}),u({variables:{addProductToCartInput:{cartId:e,reference:t,variant:r,unit:n,unitQuantity:d,instruction:i}}}).then(({data:e})=>{a(k(e.addProductToGuestCart.products)({reference:t,variant:r})),c({pricesSummary:e.addProductToGuestCart.pricesSummary}),o.setSuccess({reference:t,variant:r})}).catch(e=>{o.setError({reference:t,variant:r,error:e,message:s?.errors?.addProduct})})},[o,u,e,a,c,s?.errors?.addProduct])})(a),l=(({cartId:e,products:a,updateProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(At,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({productId:t,variant:r,unit:d,unitQuantity:i,instruction:l,substitutes:C})=>{if(!t||!a[t])return;const{reference:p}=a[t];c.setProgress({reference:p,variant:r}),n({variables:{updateProductInCartInput:{cartId:e,productId:t,variant:r,unit:d,unitQuantity:i,instruction:l,substitutes:C}}}).then(async({data:t})=>{o(k(t.updateProductInGuestCart.products)({reference:p,variant:r})),s({pricesSummary:t.updateProductInGuestCart.pricesSummary}),c.setSuccess({reference:p,variant:r})}).catch(t=>{c.setError({reference:p,variant:r,error:t,message:u?.errors?.updateProduct})})},[a,c,n,e,o,s,u?.errors?.updateProduct])})(a),C=(({cartId:e,products:a,removeProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(Tt,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({productId:t})=>{const{reference:r,variant:d}=a[t];c.setProgress({reference:r,variant:d}),n({variables:{deleteProductInCartInput:{cartId:e,productId:t}}}).then(({data:e})=>{o({productId:t}),s({pricesSummary:e.deleteProductInGuestCart.pricesSummary}),c.setSuccess({reference:r,variant:d})}).catch(t=>{c.setError({reference:r,variant:d,error:t,message:u?.errors?.removeProduct})})},[a,c,n,e,o,s,u?.errors?.removeProduct])})(a),p=(({create:r,remove:a})=>t.useCallback(async({clientId:t})=>{const o=await a();e.h(o)&&r({storeReference:o.store.reference,operationalModel:o.operationalModel,clientId:t})},[r,a]))({create:c,remove:n}),m=(({load:r,reset:a,validate:o})=>t.useCallback(async({cartId:t,callback:c})=>{if(await a(),!t||0===t.length||null==t)return void c();const s=await r({cartId:t});e.h(s?.products)&&await o({cartId:s.id}),c()},[r,a,o]))({load:u,reset:a.reset,validate:o});return{addProduct:i,clear:p,create:c,initializer:m,load:u,refetch:()=>u({cartId:a.cart}),remove:n,removeProduct:C,restart:d,type:S.GUEST_CART,updateProduct:l,validate:o}},Ot={reason:"CART_ADDRESS_HAS_NO_COVERAGE"},Mt=({issues:t=[]})=>{const e={reason:void 0};return{isInvalid:!0,code:(t.find(t=>$[t.reason])||e).reason}};var Rt=r.gql`
  ${b}
  ${h}
  ${A}
  ${_}
  ${D}
  ${O}
  mutation UpdateCouponInEcommerceCart($updateCouponInput: CouponInput!) {
    updateCouponInEcommerceCart(updateCouponInput: $updateCouponInput) {
      id
      operationalModel
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      coupon {
        ...CartCoupon
      }
      validationIssues {
        productId
        reason
        type
      }
      status
    }
  }
`;const Nt=({setCart:e,cart:a,checkoutV3:o})=>{const[c]=r.useMutation(Rt,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({updateCouponInEcommerceCart:{products:t,...r}})=>{((t=[])=>t.some(t=>$[t.reason]))(r.validationIssues)?e(o?.enabled?a:{...a,coupon:Mt({issues:r.validationIssues})}):e(r)},onError:t=>{const{extensions:{code:r},message:o}=t?.graphQLErrors?.[0]||{extensions:{code:""}};e({...a,coupon:{isInvalid:!0},code:r,message:o})}});return t.useCallback(async({couponCode:t,cartId:e})=>{const{data:{updateCouponInEcommerceCart:r}={}}=await c({variables:{updateCouponInput:{cartId:e,couponCode:t}}});return r},[c])};var kt=r.gql`
  ${h}
  ${a.C}
  mutation AddProductToEcommerceCart(
    $addProductToCartInput: AddProductToCartInput!
  ) {
    addProductToEcommerceCart(addProductToCartInput: $addProductToCartInput) {
      id
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var xt=r.gql`
  ${b}
  ${h}
  ${a.C}
  ${A}
  ${_}
  ${D}
  mutation ConvertGuestToEcommerceCart($cartId: ID!) {
    convertGuestToEcommerceCart(cartId: $cartId) {
      id
      operationalModel
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      status
    }
  }
`;var Ut=r.gql`
  ${b}
  ${h}
  ${a.C}
  ${a.a}
  ${A}
  ${_}
  ${D}
  ${O}
  mutation GetActiveOrCreateEcommerceCart(
    $createCartInput: CreateEcommerceCartInput!
  ) {
    getActiveOrCreateEcommerceCart(createCartInput: $createCartInput) {
      id
      operationalModel
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      products {
        ...CartProduct
      }
      specialProducts {
        ...CartSpecialProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      coupon {
        ...CartCoupon
      }
      status
    }
  }
`;var Gt=r.gql`
  ${b}
  ${h}
  ${a.C}
  ${a.a}
  ${A}
  ${a.V}
  ${_}
  ${D}
  ${O}
  ${Y}
  ${q}
  query GetEcommerceCartById($cartId: ID!) {
    getEcommerceCart(cartId: $cartId) {
      id
      operationalModel
      products {
        ...CartProduct
      }
      specialProducts {
        ...CartSpecialProduct
      }
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      status
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      coupon {
        ...CartCoupon
      }
      deliverySlot {
        ...deliverySlot
      }
      validationIssues {
        ...validationIssue
      }
      billing {
        ...billing
      }
      paymentConfigurationId
    }
  }
`;var Lt=r.gql`
  mutation PurchaseEcommerceCart($purchaseCartInput: PurchaseCartInput!) {
    purchaseEcommerceCart(purchaseCartInput: $purchaseCartInput) {
      id
      status
      operationalModel
      jobId
      jobNumber
      coupon
      lobbyScreenToken
      jobExtenalId
      purchaseDetails {
        id
        jobId
        jobNumber
      }
    }
  }
`;var qt=r.gql`
  ${b}
  ${D}
  ${h}
  mutation DeleteEcommerceCart($cartId: ID!) {
    deleteEcommerceCart(cartId: $cartId) {
      id
      operationalModel
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      status
    }
  }
`;var wt=r.gql`
  ${h}
  mutation DeleteProductInEcommerceCart(
    $deleteProductInCartInput: DeleteProductInCartInput!
  ) {
    deleteProductInEcommerceCart(
      deleteProductInCartInput: $deleteProductInCartInput
    ) {
      id
      pricesSummary {
        ...CartPricesSummary
      }
      status
    }
  }
`;var Vt=r.gql`
  ${h}
  mutation DeleteSpecialProductInEcommerceCart(
    $deleteSpecialProductInCartInput: DeleteSpecialProductInCartInput!
  ) {
    deleteSpecialProductInEcommerceCart(
      deleteSpecialProductInCartInput: $deleteSpecialProductInCartInput
    ) {
      id
      pricesSummary {
        ...CartPricesSummary
      }
      status
    }
  }
`;var Bt=r.gql`
  fragment CartLoyaltyUpd on LoyaltyBasicModel {
    selectedRedemption {
      points
    }
  }
`,Qt=r.gql`
  ${b}
  ${h}
  ${A}
  ${a.V}
  ${_}
  ${D}
  ${O}
  ${Y}
  ${q}
  ${Bt}
  mutation UpdateEcommerceCart($updateCartInput: UpdateEcommerceCartInput!) {
    updateEcommerceCart(updateCartInput: $updateCartInput) {
      id
      operationalModel
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      status
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      coupon {
        ...CartCoupon
      }
      deliverySlot {
        ...deliverySlot
      }
      validationIssues {
        ...validationIssue
      }
      billing {
        ...billing
      }
      loyalty {
        ...CartLoyaltyUpd
      }
      paymentConfigurationId
    }
  }
`;const jt=({setCart:e,cartStatus:a})=>{const o=t.useCallback(({updateEcommerceCart:{products:t,...r}})=>{const o=((t=[])=>t.filter(t=>t.type===E))(r.validationIssues);return e(r),!(o.length>0)||(a.setError({error:o[0],tags:["update-cart-validation-error"]}),!1)},[a,e]),c=t.useCallback(t=>{a.setError({error:t,tags:["update-cart-error"]})},[a]),[s]=r.useMutation(Qt,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:o,onError:c});return t.useCallback(async({storeReference:t,operationalModel:e,addressId:r,cartId:a,slot:u,groupId:n,paymentMethod:d,billing:i,paymentConfigurationId:l,loyalty:C,onCompleted:p,onError:m,onlinePaymentParams:I})=>{const P={variables:{updateCartInput:{cartId:a,storeReference:t,operationalModel:e,addressId:r,slot:u,groupId:n,paymentMethod:d,billing:i,paymentConfigurationId:l,loyalty:C,onlinePaymentParams:I}}};p&&(P.onCompleted=t=>{const e=o(t);p(e)}),p&&(P.onError=t=>{c(t),m(t)}),await s(P)},[s,o,c])};var Ft=r.gql`
  ${h}
  ${a.C}
  mutation UpdateProductInEcommerceCart(
    $updateProductInCartInput: UpdateProductInCartInput!
  ) {
    updateProductInEcommerceCart(
      updateProductInCartInput: $updateProductInCartInput
    ) {
      id
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var zt=r.gql`
  ${h}
  ${a.C}
  mutation UpdateSpecialProductInEcommerceCart(
    $updateSpecialProductInEcommerceCartInput: UpdateSpecialProductInEcommerceCartInput!
  ) {
    updateSpecialProductInEcommerceCart(
      updateSpecialProductInEcommerceCartInput: $updateSpecialProductInEcommerceCartInput
    ) {
      id
      products {
        ...CartProduct
      }
      pricesSummary {
        ...CartPricesSummary
      }
    }
  }
`;var Yt=r.gql`
  fragment CartLoyalty on LoyaltyModel {
    availablePoints {
      conversionRate
      conversionValue
      points
    }
    redeemable {
      points
      conversionRate
      conversionValue
    }
    selectedRedemption {
      points
      conversionRate
      conversionValue
    }
  }
`,Ht=r.gql`
  ${b}
  ${h}
  ${ot}
  ${a.a}
  ${A}
  ${a.V}
  ${_}
  ${D}
  ${O}
  ${Yt}
  mutation ValidateEcommerceCart($cartId: ID!) {
    validateEcommerceCart(cartId: $cartId) {
      id
      operationalModel
      products {
        ...ValidateCartProduct
      }
      specialProducts {
        ...CartSpecialProduct
      }
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      validationIssues {
        ...validationIssue
      }
      coupon {
        ...CartCoupon
      }
      status
      loyalty {
        ...CartLoyalty
      }
    }
  }
`,Kt=r.gql`
  ${b}
  ${h}
  ${ot}
  ${a.a}
  ${A}
  ${a.V}
  ${_}
  ${D}
  ${O}
  ${Yt}
  ${st}
  mutation ValidateEcommerceCart($cartId: ID!, $allowSplitOrders: Boolean) {
    validateEcommerceCart(
      cartId: $cartId
      allowSplitOrders: $allowSplitOrders
    ) {
      id
      operationalModel
      products {
        ...ValidateCartProduct
      }
      specialProducts {
        ...CartSpecialProduct
      }
      customer {
        ...cartCustomer
      }
      store {
        ...CartStore
      }
      address {
        ...cartAddress
      }
      pricesSummary {
        ...CartPricesSummary
      }
      storeConfiguration {
        ...CartStoreConfiguration
      }
      validationIssues {
        ...validationIssue
      }
      coupon {
        ...CartCoupon
      }
      status
      loyalty {
        ...CartLoyalty
      }
      groups {
        ...CartGroups
      }
    }
  }
`;const Wt=e=>{const a=(({setCart:e,addProducts:a,cartStatus:o,reset:c})=>{const[s]=r.useMutation(Ut,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({getActiveOrCreateEcommerceCart:{products:t,specialProducts:r=[],...o}})=>{a([...t,...G(r)]),e(o)},onError:t=>{c(),o.setError({error:t})}});return t.useCallback(async({storeReference:t,operationalModel:e,addressId:r})=>{const{data:a={}}=await s({variables:{createCartInput:{storeReference:t,operationalModel:e,addressId:r}}});return a.getActiveOrCreateEcommerceCart||null},[s])})(e),o=(({cartStatus:e,clientId:a,enabledCoverageValidation:o})=>{const[c]=r.useLazyQuery(n.r,{fetchPolicy:"no-cache"}),s=t.useCallback(t=>{const{operationalModel:e="PICK_UP"}=t||{};return!o||"DELIVERY"!==e},[o]),u=t.useCallback(t=>Boolean(t?.address?.id),[]),d=t.useCallback(async({cart:t,operationalModel:e})=>{const{data:r={}}=await c({variables:{clientId:a,operationalModel:e,addressId:t?.address?.id}});return r?.getStoresNearbyByAddress},[a,c]);return t.useCallback(async({cart:t})=>{const{operationalModel:r="PICK_UP"}=t||{};if(s(t))return{coverageIssues:[]};if(!u(t))return e.setError({error:Ot}),{coverageIssues:[Ot]};const a=(({cart:t,nearbyStoresByAddress:e=[]})=>e.some(e=>e?.id===t?.store?.id))({cart:t,nearbyStoresByAddress:await d({cart:t,operationalModel:r})});return a?{coverageIssues:[]}:(e.setError({error:Ot}),{coverageIssues:[Ot]})},[e,d,u,s])})(e),c=(({setCart:e,cartStatus:a,addProducts:o,allowSplitOrders:c,setGroups:s,coverage:u})=>{const n=c?Kt:Ht,[d]=r.useMutation(n,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:async({validateEcommerceCart:{products:t=[],specialProducts:r=[],...c}})=>{const{validationIssues:n,isCartSuccessful:d}=await(async(t,{coverage:e})=>{const{coverageIssues:r=[]}=await(e?.({cart:t}))||{};return{validationIssues:[...t?.validationIssues||[],...r],isCartSuccessful:0===r?.length}})(c,{coverage:u});e({...c,validationIssues:n}),s(c?.groups||[]),o([...t,...G(r)]),d&&a.setSuccess()},onError:t=>{a.setError({error:t})}});return t.useCallback(async({cartId:t})=>{a.setProgress();const{data:e={}}=await d({variables:{cartId:t,allowSplitOrders:c}});return e.validateEcommerceCart||null},[d,a,c])})({...e,coverage:o}),s=(({setCart:e,addProducts:a,cartStatus:o,reset:c})=>{const[s]=r.useLazyQuery(Gt,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({getEcommerceCart:{products:t,specialProducts:r=[],...o}})=>{a([...t,...G(r)]),e(o)},onError:t=>{c(),o.setError({error:t})}});return t.useCallback(async({cartId:t})=>{const{data:e={}}=await s({variables:{cartId:t}});return e.getEcommerceCart||null},[s])})(e),u=jt(e),d=(({cartId:e,reset:a,cartStatus:o})=>{const[c]=r.useMutation(qt,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({deleteEcommerceCart:t})=>{t.status===y&&a()},onError:t=>o.setError({error:t})});return t.useCallback(async()=>{if(!e)return null;const{data:t={}}=await c({variables:{cartId:e}});return t.deleteEcommerceCart&&Z(t.deleteEcommerceCart)?t.deleteEcommerceCart:null},[e,c])})(e),i=(({setCart:e,addProducts:a,cartStatus:o,reset:c})=>{const[s]=r.useMutation(xt,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({convertGuestToEcommerceCart:{products:t,...r}})=>{a(t),e(r)},onError:t=>{c(),o.setError({error:t})}});return t.useCallback(async({cartId:t})=>{const{data:e={}}=await s({variables:{cartId:t}});return e.convertGuestToEcommerceCart||null},[s])})(e),l=v({cart:e.cart,create:a,update:u}),m=C({create:a,remove:d}),g=(({cartId:e,addProduct:a,productStatus:o,updateCart:c,copy:s})=>{const[u]=r.useMutation(kt,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({reference:t,variant:r,unit:n,unitQuantity:d,instruction:i})=>{o.setProgress({reference:t,variant:r}),u({variables:{addProductToCartInput:{cartId:e,reference:t,variant:r,unit:n,unitQuantity:d,instruction:i}}}).then(({data:e})=>{a(k(e.addProductToEcommerceCart.products)({reference:t,variant:r})),c({pricesSummary:e.addProductToEcommerceCart.pricesSummary}),o.setSuccess({reference:t,variant:r})}).catch(e=>{o.setError({reference:t,variant:r,error:e,message:s?.errors?.addProduct})})},[e,a,u,o,c,s])})(e),f=(({cartId:e,products:a,updateProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(Ft,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({productId:t,variant:r,unit:d,unitQuantity:i,instruction:l,substitutes:C})=>{const{reference:p}=a[t];c.setProgress({reference:p,variant:r}),n({variables:{updateProductInCartInput:{cartId:e,productId:t,variant:r,unit:d,unitQuantity:i,instruction:l,substitutes:C}}}).then(async({data:t})=>{await o(k(t.updateProductInEcommerceCart.products)({reference:p,variant:r})),s({pricesSummary:t.updateProductInEcommerceCart.pricesSummary}),c.setSuccess({reference:p,variant:r})}).catch(t=>{c.setError({reference:p,variant:r,error:t,message:u?.errors?.updateProduct})})},[a,c,n,e,o,s,u])})(e),E=(({cartId:e,products:a,updateProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(zt,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({specialProductId:t,unit:r,unitQuantity:d,instruction:i})=>{const{reference:l}=a[t];c.setProgress({reference:l}),n({variables:{updateSpecialProductInEcommerceCartInput:{cartId:e,specialProductId:t,unit:r,unitQuantity:d,instruction:i}}}).then(({data:t})=>{o(k(t.updateSpecialProductInEcommerceCart.specialProducts)({reference:l})),s({pricesSummary:t.updateSpecialProductInEcommerceCart.pricesSummary}),c.setSuccess({reference:l})}).catch(t=>{c.setError({reference:l,error:t,message:u?.errors?.updateProduct})})},[e,a,o,n,c,s,u])})(e),$=(({cartId:e,products:a,removeProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(wt,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({productId:t})=>{const{reference:r,variant:d}=a[t];c.setProgress({reference:r,variant:d}),n({variables:{deleteProductInCartInput:{cartId:e,productId:t}}}).then(async({data:e})=>{await o({productId:t}),s({pricesSummary:e.deleteProductInEcommerceCart.pricesSummary}),c.setSuccess({reference:r,variant:d})}).catch(t=>{c.setError({reference:r,variant:d,error:t,message:u?.errors?.removeProduct})})},[a,c,n,e,o,s,u])})(e),b=(({cartId:e,products:a,removeProduct:o,productStatus:c,updateCart:s,copy:u})=>{const[n]=r.useMutation(Vt,{context:{version:"v3"},fetchPolicy:"no-cache"});return t.useCallback(({specialProductId:t})=>{const{reference:r}=a[t];c.setProgress({reference:r}),n({variables:{deleteSpecialProductInCartInput:{cartId:e,specialProductId:t}}}).then(async({data:e})=>{o({productId:t}),s({pricesSummary:e.deleteSpecialProductInEcommerceCart.pricesSummary}),c.setSuccess({reference:r})}).catch(t=>{c.setError({reference:r,error:t,message:u?.errors?.removeProduct})})},[e,a,n,o,c,s,u])})(e),T=I(e),h=Nt(e),A=(({cartId:e,setPurchaseData:a,cartStatus:o,allowSplitOrders:c})=>{const[s]=r.useMutation(Lt,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:({purchaseEcommerceCart:t})=>{a(t),o.setSuccess()},onError:t=>{o.setError({error:{...t,reason:"INVALID_SLOT_ID"}})}});return t.useCallback(async({paymentInput:t,curbside:r})=>{if(!e)return null;o.setProgress();const{data:a={}}=await s({variables:{purchaseCartInput:{cartId:e,paymentInput:t,allowSplitOrders:c,curbside:r}}});return a.purchaseEcommerceCart||null},[e,o,c,s])})({cartId:e.cartId,setPurchaseData:e.setPurchaseData,cartStatus:e.cartStatus,allowSplitOrders:e.allowSplitOrders});return{removeSpecialProduct:b,updateSpecialProduct:E,addProduct:g,clear:m,create:a,initializer:p({load:a,convert:i,reset:e.reset,validate:c,loadById:s}),load:a,refetch:P({...e,validate:c,create:a}),remove:d,removeProduct:$,restart:l,type:S.LOGGED_CART,updateProduct:f,validate:c,loadDeliverySlots:T,addCoupon:h,purchase:A}},Xt=l.default.createContext();exports.C=function({site:t,children:e,monitor:r,db:a,copy:o,config:c={enabledCoverageValidation:!1,clientId:"",checkoutV3:{}}}){const s=gt({useCallCenterCart:nt,useLoggedCart:Wt,useGuestCart:Dt,monitor:r,db:a,copy:o,site:t,config:c});return d.jsx(Xt.Provider,{value:s,children:e})},exports.a=S,exports.u=()=>{const t=l.default.useContext(Xt);if(!t)throw new Error("CartContext: no context");return t};